export const DashboardType = {
  INVESTOR: "INVESTOR",
  ADVISOR: "ADVISOR",
  ASSOCIATE: "ASSOCIATE",
};

export const blockInvalidChar = (e) =>
  ["+", "-"].includes(e.key) && e.preventDefault();

export const token = localStorage.getItem("token");

export const getUserType = (userInfo) => {
  if (userInfo?.userType === DashboardType.INVESTOR) {
    return "client";
  }
  return "advisor";
};
